import * as React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import AttachementIcon from 'material-ui/svg-icons/file/attachment';
import { white, yellow500, red500 } from 'material-ui/styles/colors';

type Props = {
  readonly onFileChangeHandler?: (file?: File) => void
  readonly fileExtensions?: Array<string>
  readonly fileSizeLimit?: Number
};

type States = {
  readonly file?: File
  readonly fileSizeError: string
  readonly fileFormatError: string
};

class FileUploadComponent extends React.Component<Props, States> {

  private selectFileEvent: HTMLInputElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      file: undefined,
      fileSizeError: '',
      fileFormatError: ''
    };
  }

  render() {
    return (
      this.renderSelectButton()
    );
  }

  private renderSelectButton = (): JSX.Element => {
    return(
      <div>
        <RaisedButton
          primary={true}
          label={'Select File'}
          icon={<AttachementIcon color={white} hoverColor={yellow500} />}
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            this.selectFileEvent.click();
          }}
        />
        <div><strong>{(this.state.file) ? this.state.file.name : ''}</strong></div>
        <div style={{ color: red500 }}>{this.state.fileFormatError}</div>
        <div style={{ color: red500 }}>{this.state.fileSizeError}</div>
        <input
          ref={(ref: HTMLInputElement) => this.selectFileEvent = ref}
          type="file"
          onChange={this.handleFileChange}
          style={{display: 'none'}}
        />
      </div>
    );
  }

  private handleFileChange = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();

    const { fileExtensions, fileSizeLimit } = this.props;

    if (e.currentTarget.value.length !== 0) {
      let reader = new FileReader();
      const file: File | undefined = e.currentTarget.files && e.currentTarget.files.length > 0 ?
        e.currentTarget.files.item(0) : 
        undefined;

      const valid = !fileExtensions || fileExtensions.map((v: string) => {
        if (file) {
          return file.name.substr(file.name.length - v.length, v.length).toLowerCase() === v.toLowerCase();
        } else {
          return false;
        }
      }).includes(true);

      if (!valid) {
        return this.setState(
          {
            file: undefined,
            fileFormatError: 'File extension is invalid.',
            fileSizeError: ''
          },
          this.fileChangeCallback
        );
      }

      if (file !== undefined && fileSizeLimit && file.size > fileSizeLimit) {
        return this.setState(
          {
            file: undefined,
            fileFormatError: '',
            fileSizeError: 'File size is too big'
          },
          this.fileChangeCallback
        );
      } else if (file) {
        reader.onloadend = () => {
          this.setState(
            {
              file: file,
              fileFormatError: '',
              fileSizeError: ''
            },
            this.fileChangeCallback
          );
        };
    
        reader.readAsDataURL(file);
      }
    }
  }

  private fileChangeCallback = (): void => {
    const { onFileChangeHandler } = this.props;
    const { file } = this.state;

    if (onFileChangeHandler) {
      onFileChangeHandler(file);
    }
  }
}

export default FileUploadComponent;


// WEBPACK FOOTER //
// ./src/util/fileUploadComponent.tsx